document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
    });
  }

  document.querySelectorAll('[data-quantity]').forEach((wrapper) => {
    const input = wrapper.querySelector('input');
    wrapper.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const next = Math.max(1, Number(input.value || 1) + Number(button.dataset.step));
        input.value = next;
      });
    });
  });
});
